import { apiDataManagerBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const addOnsApiRoutes = {
    get: new URL("addons/", apiDataManagerBaseURL),
    execute: new URL("addons/", apiDataManagerBaseURL)
};

export class AddOnsAPI {
    static get() {
        return API.authenticatedRequest({
            url: addOnsApiRoutes.get,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static execute(addOn, parameters) {
        return API.authenticatedRequest({
            url: new URL(addOn, addOnsApiRoutes.execute),
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(parameters)
        });
    }
}
